export default "__VITE_ASSET__bO8Hz8u0__"